<template>
  <div>
    <breadcrumb :routerList="[{to:'/contract-list',title:'合同列表'},{to: $route.fullPath, title:'合同修改'}]"/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formLine weekplandetail" style="padding-bottom: 100px;">
          <el-form :model="formInline" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
            <el-form-item label="合同名称" class="h-elformWrap-2">
              <el-input readonly v-model="formInline.contractName"></el-input>
            </el-form-item>
            <el-form-item label="云超市合同号" class="h-elformWrap-2">
              <el-input readonly v-model="formInline.contractCode"></el-input>
            </el-form-item>
            <el-col>
              <el-form-item label="原合同开始时间" class="h-elformWrap-2">
                <el-input readonly v-model="formInline.contractStarttime"></el-input>
              </el-form-item>
              <el-form-item label="新合同开始时间" class="h-elformWrap-2">
                <el-input readonly v-model="formUpdate.contractStarttime"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="原合同结束时间" class="h-elformWrap-2">
                <el-input readonly v-model="formInline.contractEndtime"></el-input>
              </el-form-item>
              <el-form-item label="新合同结束时间" class="h-elformWrap-2">
                <el-input readonly v-model="formUpdate.contractEndtime"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
        <div >
          <div class="h-pieceTitle2" style="margin:5px 0 16px 10px">
            <h1>产品信息</h1>
          </div>
          <el-form ref="form4" :model="formInline">
            <el-table
                ref="multipleTable"
                :data="formInline.productList"
                style="width: 100%"
            >
              <el-table-column
                  type="index"
                  label="#" width="40">
              </el-table-column>
              <el-table-column
                  prop="productId"
                  label="产品型号" width="180">
              </el-table-column>
              <el-table-column
                  prop="productName"
                  label="产品名称" width="240">
              </el-table-column>
              <el-table-column
                  prop="oldCgjingli"
                  min-width="280"
                  label="原采购经理">
                <template scope="scope">
                  <brselect :disabled="true" :multiple="true" category="cg_manage" v-model="scope.row.oldCgjingli" :v="scope.row.oldCgjingli"
                  />
                </template>
              </el-table-column>
              <el-table-column
                  prop="cgjingli"
                  min-width="280"
                  label="新采购经理">
                <template scope="scope">
                  <brselect :disabled="true" :multiple="true" category="cg_manage" v-model="scope.row.cgjingli" :v="scope.row.cgjingli"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div class="h-table" v-if="taskstatus == '0'">
          <div class="h-pieceTitle2 hang">
            <h1 class="h1" style="margin: 5px 0px 16px 10px;" >审批意见</h1>
            <div class="h-formLine weekplandetail">
              <el-form :model="spform" label-position="right" :inline="true"
                       class="demo-ruleForm h-formbLine">
                <el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:20px" >
                  <el-input v-model="spform.shpyj" placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="h-txtCenter h-mrt60">
        <el-button
            class="el-button h-btn h-bBtn h-bgwhite el-button--default"
            @click="cancel">
          返回
        </el-button>
        <el-button
            v-if="taskstatus == '0'"
            class="el-button h-btn h-bBtn h-bgred el-button--default"
            @click="submit(1)">
          驳回
        </el-button>
        <el-button
            v-if="taskstatus == '0'"
            class="el-button h-btn h-bBtn h-bggreen el-button--default"
            @click="submit(2)">
          通过
        </el-button>
        <el-button
            class="el-button h-btn el-button--default"
            @click="viewpress">
          审批跟踪
        </el-button>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  </div>
</template>

<script>
import ss from "../../../api/SystemService";
import util from "../../../utils/util";
import big from "big.js";
import { cloneDeep } from 'loadsh'
export default {
  name: 'leftMenu',
  data() {
    return {
      customerlabel: "客户名称",
      cgflag: false,
      zlflag: false,
      bzflag: false,
      //表单
      formInline: {},
      //表单
      formUpdate: {
      },
      contractId: this.$route.query.key,
      //多选
      checkList: [],
      fileList: [],
      zlxh: [
        {
          productType: 'NA4',
          productCode: 'BF0260B04',
          productName: 'DW-25W198',
          rentNum: '8'
        }
      ],
      fukuanobj: [
        {
          nodeName: "",
          newflag: false,
          paymentRatio: "",
          paymentAmount: "",
          netValue: "",
          paymentDays: "",
          billPayMonty: ""
        }
      ],
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.formUpdate.contractEndtime) {
            return time.getTime() > new Date(this.formUpdate.contractEndtime.replace(/-/gi,'/')).getTime();
          }
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.formUpdate.contractStarttime) {
            return time.getTime() < new Date(this.formUpdate.contractStarttime.replace(/-/gi,'/')).getTime();
          }
        }
      },
      instid: '',
      showhistory: false,
      oldForm: {},
      spform: {
        shpyj: ''
      }
    }
  },
  methods: {
    cancel() {
      this.$router.push("contract-list");
    },
    viewpress(){
      this.showhistory = true;
    },
    submit(type) {

      let form = {
        taskid: this.$route.query.taskid,
        shenpiFlag: type,
        shenpiyijian: this.spform.shpyj,
        ...this.oldForm
      }

      if(type == 1 && !this.spform.shpyj){
        this.$msg.msge("驳回必须输入审批意见！");
        return
      }


      var confirmMsg = type == '2' ? "通过后信息会更新,确认通过?" : "确认驳回?";
      this.$msg.confirm(confirmMsg, () => {
        submitForm.call(this);
      })

      // TODO 验证
      function submitForm(){
        ss.contractService.shenpiEdit(form).then(rd => {
          if (rd.f) {
            this.$msg.msgs("提交成功！");
            this.$router.back()
          } else {
            this.$msg.msge("提交失败！" + rd.msg);
          }
        })
      }
    },
    formatDate(date){
      if (this.isNotEmpty(date)) {
        function addDateZero(num) {
          return (num < 10 ? "0" + num : num);
        }
        let d = new Date(date);
        let format = d.getFullYear()+"-"+addDateZero(d.getMonth()+1)+"-"+addDateZero(d.getDate());
        return format;
      }
    },
  },
  created() {
    let instid = this.instid =  this.$route.query.instid;
    this.testID =  this.$route.query.ywid
    this.taskstatus = this.$route.query.taskstatus
  },
  mounted() {
    ss.contractService.selectEditById({id: this.$route.query.ywid}).then(rd => {
      // this.formInline = rd.obj;
      if(rd.f){
        this.oldForm = cloneDeep(rd.obj);
        this.formInline = rd.obj;
        this.formUpdate['contractStarttime'] = this.formInline.contractStarttime;
        this.formUpdate['contractEndtime'] = this.formInline.contractEndtime;
        this.formInline['contractStarttime'] = this.formInline.oldContractStarttime;
        this.formInline['contractEndtime'] = this.formInline.oldContractEndtime;
      }
    });
  }
}
</script>

<style scoped>
.texts {
  color: #2a89d6;
  font-size: 18px;
  text-decoration: underline
}
</style>
<style>
/* .h-formbLine .el-form-item__label{
	width: 18%;
} */
.yearIcon .el-input:after {
  content: '年';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}

.weekplandetail .h-formbLine .el-form-item__label {
  width: 36%;
  text-align: right;
}

.weekplandetail .h-formbLine .el-form-item__content {
  width: 64%;
}

.weekplandetail .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
  padding-right: 0.5rem
}

.weekplandetail .h-formbLine .h-elformWrap-1 {
  width: 100%;
  padding-right: 0.5rem
}

.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 10.4%;
}

.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 89.6%;
}

.weekplandetail2 .h-formbLine .h-elformWrap-2 {
  width: 100%;
  padding-right: 0.5rem
}

.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__label {
  width: 22.4%;
  vertical-align: middle;
}

.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__content {
  width: 77.6%;
}

.weekplandetail1 .h-formbLine .h-elformWrap-2 {
  width: 100%;
  padding-right: 0.5rem
}

.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__label {
  width: 7%;
  vertical-align: middle;
}

.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__content {
  width: 93%;
}
</style>
